import "./decoration.css"

export default function Decoration() {
    return (
        <div className="decoration"></div>

    )

}